module.exports = __webpack_public_path__ + "officialStatic/img/softProductMid.7e984f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/softProductMid.jpg
// module id = +iVj
// module chunks = 0